import { Injectable, Inject } from '@angular/core';
import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';

import { HttpClient } from '@angular/common/http';
import { OtpVerifyCode } from './otp-verify-code';

@Injectable()
export class OtpVerifyCodeInputTrigger extends StrictBehavior {
  constructor(
    public http: HttpClient,
    @Inject('ApproveMeOtpVerifyCode') public verifyCodeBehavior: OtpVerifyCode
  ) {
    super();
  }

  async executeBehavior(args: any, ctx: BehaviorContext): Promise<any> {
    const currentVal = ctx.formGroup.value[ctx.target.model.formControlName];

    const isPristine = ctx.get('otpPristine');
    if (isPristine && currentVal && currentVal.length === 6) {
      ctx.set('otpPristine', false);
      await this.verifyCodeBehavior.execute(args, ctx);
    }
  }
}
